import { Promise as bluebird } from 'bluebird';
import { fetchShopifyOrder, IShopifyOrder } from "@merchstores/admin/components/MerchStoreOrders";
import { IOrderItem } from ".";
import { IMerchStore } from "@merchstores/admin/components/MerchStore";
import { mapLineItemToOrderItem } from '../MerchStoreOrders/ShopifyLineItem';


export async function combineOrdersItems(
  merchStore: IMerchStore, 
  orders: Array<IShopifyOrder>)
: Promise<Array<IOrderItem>> 
{
  let allItems: Array<IOrderItem> = [];

  await bluebird.mapSeries(orders, async order => {
    
    const orderItems: Array<IOrderItem> = [];

    await fetchShopifyOrder({ storeCode: merchStore.storeCode, orderId: order.id }).then(data => {
      data.order.lineItems?.forEach(lineItem => {
        orderItems.push(mapLineItemToOrderItem(lineItem));
      })
    })

    allItems = allItems.concat(orderItems);
  });

  return allItems;
}